import type { IconFieldDesignTokens } from '@primeuix/themes/types/iconfield'
import type { InputNumberDesignTokens } from '@primeuix/themes/types/inputnumber'
import type { InputTextDesignTokens } from '@primeuix/themes/types/inputtext'
import type { TextareaDesignTokens } from '@primeuix/themes/types/textarea'

import { bothSchemes } from '../utils'

/**
 * Поля ввода в макете: 358x50, r=20, фон #F7F7F7, без бордера,
 * placeholder #ABADB0 / 13 Medium, иконка 24px с отступом 13px.
 * Базовая геометрия — в semantic.formField, здесь только специфика.
 */
const fieldColors = {
  background: 'var(--surface-muted)',
  disabledBackground: 'var(--secondary-100)',
  filledBackground: 'var(--surface-muted)',
  filledHoverBackground: 'var(--surface-muted)',
  filledFocusBackground: 'var(--surface-muted)',
  borderColor: 'transparent',
  hoverBorderColor: 'transparent',
  focusBorderColor: 'var(--secondary-200)',
  invalidBorderColor: 'var(--primary-500)',
  color: 'var(--text-color)',
  disabledColor: 'var(--text-color-secondary)',
  placeholderColor: 'var(--text-color-secondary)',
  invalidPlaceholderColor: 'var(--primary-500)',
  shadow: 'none',
} as const

export const inputTextConfig = (): InputTextDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-xl)',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  colorScheme: bothSchemes({ root: fieldColors }),
})

export const textareaConfig = (): TextareaDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-xl)',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  colorScheme: bothSchemes({ root: fieldColors }),
})

/** Счётчик количества товара в корзине — компактный, пилюлей. */
export const inputNumberConfig = (): InputNumberDesignTokens => ({
  root: {
    transitionDuration: '.15s',
  },
  button: {
    width: '32px',
    borderRadius: 'var(--radius-pill)',
    verticalPadding: 'var(--space-2)',
  },
  colorScheme: bothSchemes({
    button: {
      background: 'var(--surface-muted)',
      hoverBackground: 'var(--secondary-100)',
      activeBackground: 'var(--secondary-200)',
      borderColor: 'transparent',
      hoverBorderColor: 'transparent',
      activeBorderColor: 'transparent',
      color: 'var(--text-color)',
      hoverColor: 'var(--text-color)',
      activeColor: 'var(--text-color)',
    },
  }),
})

/** Поисковая строка на Главной и в Меню. */
export const iconFieldConfig = (): IconFieldDesignTokens => ({
  colorScheme: bothSchemes({
    icon: { color: 'var(--icon-color)' },
  }),
})
